import { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import synapseImg from "../../Assets/synapse.png";
import Toolstack from "./Toolstack";
import ContactForm from "../ContactForm";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import SectionTitle from "../SectionTitle";

function About() {
  const [showModal, setShowModal] = useState(false);
  const bicycleSectionRef = useRef(null);
  const bicycleWrapperRef = useRef(null);
  useScrollAnimation();

  useEffect(() => {
    const section = bicycleSectionRef.current;
    const wrapper = bicycleWrapperRef.current;
    if (!section || !wrapper) return;

    let intervalId = null;

    const startRide = () => {
      wrapper.classList.remove("riding");
      void wrapper.offsetWidth;
      wrapper.classList.add("riding");
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startRide();
          intervalId = setInterval(startRide, 6000);
          observer.unobserve(section);
        }
      },
      { threshold: 0.05 }
    );

    observer.observe(section);
    return () => {
      observer.disconnect();
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  return (
    <Container fluid className="about-section">
      <Container>
        <Row
          style={{
            justifyContent: "center",
            alignItems: "center",
            paddingBottom: "48px",
          }}
        >
          <Col
            md={7}
            className="animate-on-scroll"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "32px",
              paddingBottom: "32px",
            }}
          >
            <Aboutcard />
            <Button
              variant="primary"
              onClick={() => setShowModal(true)}
              style={{ marginTop: "24px" }}
            >
              CONTACT ME
            </Button>
          </Col>

          <Col
            md={5}
            style={{
              paddingTop: "32px",
              paddingBottom: "32px",
              display: "flex",
              justifyContent: "center",
            }}
            className="about-img animate-on-scroll delay-1"
          >
            <img
              src={laptopImg}
              alt="Blu Gotlieb"
              className="img-fluid"
              style={{
                maxWidth: "70%",
                height: "auto",
                borderRadius: "10px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            />
          </Col>
        </Row>
      </Container>

      {/* Cannondale Synapse — full-width flyby */}
      <div className="bicycle-section" ref={bicycleSectionRef}>
        <div className="bicycle-wrapper" ref={bicycleWrapperRef}>
          <img src={synapseImg} alt="" aria-hidden="true" style={{ height: "140px", width: "auto" }} />
        </div>
      </div>

      <Container>
        <div className="animate-on-scroll" style={{ marginBottom: "48px" }}>
          <SectionTitle number={3} title="Software Skillset" />
          <Techstack />
        </div>

        <div className="animate-on-scroll" style={{ marginBottom: "64px" }}>
          <SectionTitle number={4} title="Tools I Use" />
          <Toolstack />
        </div>
      </Container>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Contact Me</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ContactForm />
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default About;
